(function ($) {
	$(document).ready(function(){

		function rewritingMenu(){
			$('.menu-wrapper').appendTo('.rewriting-menu-js');
			$('.action-icons-js').appendTo('.element-for-search-js');
			$('.icons-after-menu').appendTo('.navbar-main');
			$('.search-block-wrap').appendTo('.action-icons-js');
		}

		function returmMenu(){
			$('.menu-wrapper').appendTo('.menu-wrapper-js');
			$('.action-icons-js').appendTo('.wrap-action-icons-js');
			$('.icons-after-menu').appendTo('.wrap-icons-after-menu-js');
			$('.search-block-wrap').appendTo('.wrap-search-block-js');
		}

		if($(window).width() < 975 ){
			rewritingMenu();
		}

		$( window ).resize(function() {
			if($(window).width() < 975 ){
				rewritingMenu();
			}else{
				returmMenu();
			}
		});

		let startToggle = true;
		$('.navbar-toggler').on('click', function (e) {
			e.preventDefault();
			if(startToggle){
				$('.icons-after-menu').addClass('active');
				startToggle = false;
			}else{
				if($(this).hasClass('collapsed')){
					$('.icons-after-menu').addClass('active');
				}else{
					$('.icons-after-menu').removeClass('active');
				}
			}
		});
	})
})(jQuery);
